import client from 'client'
import type {
  BulkUpdateManualIssueIssueBulkUpdatePostMutationRequest,
  BulkUpdateManualIssueIssueBulkUpdatePostMutationResponse,
  BulkUpdateManualIssueIssueBulkUpdatePostQueryParams,
  BulkUpdateManualIssueIssueBulkUpdatePost422,
} from '../../types/BulkUpdateManualIssueIssueBulkUpdatePost.ts'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { RequestConfig, ResponseConfig, ResponseErrorConfig } from 'client'
import { useMutation } from '@tanstack/react-query'

export const bulkUpdateManualIssueIssueBulkUpdatePostMutationKey = () => [{ url: '/issue/bulk_update' }] as const

export type BulkUpdateManualIssueIssueBulkUpdatePostMutationKey = ReturnType<typeof bulkUpdateManualIssueIssueBulkUpdatePostMutationKey>

/**
 * @summary Bulk Update Manual Issue
 * {@link /issue/bulk_update}
 */
export async function bulkUpdateManualIssueIssueBulkUpdatePost(
  data: BulkUpdateManualIssueIssueBulkUpdatePostMutationRequest,
  params?: BulkUpdateManualIssueIssueBulkUpdatePostQueryParams,
  config: Partial<RequestConfig<BulkUpdateManualIssueIssueBulkUpdatePostMutationRequest>> & { client?: typeof client } = {},
) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<
    BulkUpdateManualIssueIssueBulkUpdatePostMutationResponse,
    ResponseErrorConfig<BulkUpdateManualIssueIssueBulkUpdatePost422>,
    BulkUpdateManualIssueIssueBulkUpdatePostMutationRequest
  >({ method: 'POST', url: `/issue/bulk_update`, params, data, ...requestConfig })
  return res
}

/**
 * @summary Bulk Update Manual Issue
 * {@link /issue/bulk_update}
 */
export function useBulkUpdateManualIssueIssueBulkUpdatePost(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<BulkUpdateManualIssueIssueBulkUpdatePostMutationResponse>,
      ResponseErrorConfig<BulkUpdateManualIssueIssueBulkUpdatePost422>,
      { data: BulkUpdateManualIssueIssueBulkUpdatePostMutationRequest; params?: BulkUpdateManualIssueIssueBulkUpdatePostQueryParams }
    >
    client?: Partial<RequestConfig<BulkUpdateManualIssueIssueBulkUpdatePostMutationRequest>> & { client?: typeof client }
  } = {},
) {
  const { mutation: mutationOptions, client: config = {} } = options ?? {}
  const mutationKey = mutationOptions?.mutationKey ?? bulkUpdateManualIssueIssueBulkUpdatePostMutationKey()

  return useMutation<
    ResponseConfig<BulkUpdateManualIssueIssueBulkUpdatePostMutationResponse>,
    ResponseErrorConfig<BulkUpdateManualIssueIssueBulkUpdatePost422>,
    { data: BulkUpdateManualIssueIssueBulkUpdatePostMutationRequest; params?: BulkUpdateManualIssueIssueBulkUpdatePostQueryParams }
  >({
    mutationFn: async ({ data, params }) => {
      return bulkUpdateManualIssueIssueBulkUpdatePost(data, params, config)
    },
    mutationKey,
    ...mutationOptions,
  })
}